package structs.accelbyte.promo

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Result of an AGS `platform campaign-codes get` availability check.
 *
 * - `AVAILABLE` — the code exists, the campaign is active, and
 *   `maxRedeemCountPerCode` has not been reached. Redeem will succeed.
 * - `REDEEMED` — the code has hit its max-redeem cap (we set this to 1 per
 *   code, so this branch means "already used once"). Redeem will fail.
 * - `UNKNOWN` — AGS returned a 404 or the campaign is in a state that does
 *   not allow the check to complete. Redeem behaviour is not guaranteed;
 *   the proxy surfaces this verbatim to the caller.
 */
@Serializable
enum class PromoCodeAvailability {
    @SerialName("AVAILABLE")
    AVAILABLE,

    @SerialName("REDEEMED")
    REDEEMED,

    @SerialName("UNKNOWN")
    UNKNOWN,

    @SerialName("REDEEMING")
    REDEEMING,

    @SerialName("DISABLED")
    DISABLED,

    @SerialName("UNAUTHORIZED")
    UNAUTHORIZED,
}
